module.exports = __webpack_public_path__ + "static/media/clouds.51f30482.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clouds.png
// module id = 29
// module chunks = 0